module.exports = __webpack_public_path__ + "static/media/TournamentTent_2.a6d23b94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/tournamenttent/TournamentTent_2.png
// module id = 1328
// module chunks = 3